export enum TipoSolapaVueloTams {
    Partidas = 0,
    Arribos = 1
}